import type { ComponentTemplate } from "schemas/generated/componentTemplates";

export const homePageCrossSell: ComponentTemplate = {
  id: "3104c785-2a86-42e9-8efb-1e7bca01ad86",
  storeId: null,

  scope: "left-bar",
  type: "component",
  name: "Rebuy/Rebuy Home Page Cross-sell",
  leftBarCategory: { main: "pageIntegrations", subCategory: "rebuy" },
  preview: "rebuy/home-page-cross-sell.svg",
  transforms: [],
  template: {
    id: "$uid",
    type: "rebuyWidget",
    props: {
      style: {
        alignSelf: "stretch",
        flexGrow: 1,
      },
    },
  },
};
